module.exports = __webpack_public_path__ + "img/off.4ef17e5d.jpeg";